import { render, staticRenderFns } from "./WealthWithdraw.vue?vue&type=template&id=743daa4d&scoped=true"
import script from "./WealthWithdraw.vue?vue&type=script&lang=ts&setup=true"
export * from "./WealthWithdraw.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WealthWithdraw.vue?vue&type=style&index=0&id=743daa4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743daa4d",
  null
  
)

export default component.exports